import {BaseModel} from '../_base/crud';
import {FileModel} from './file.model';
import {Creator, Language} from './user.model';

/**
 * 見積の承認が拒否された状態
 */
export const MESSAGE_STATUS_CHECK_ESTIMATE_REJECTED = -2;
/**
 * 見積の承認待ち状態
 */
export const MESSAGE_STATUS_CHECK_ESTIMATE_PENDING = -1;
/**
 * 見積の承認済み状態。この値はデフォルトにすべきではない。
 */
export const MESSAGE_STATUS_CHECK_ESTIMATE_ACCEPTED = 0;
/**
 * 通常の状態。この値をデフォルトにすべき。
 */
export const MESSAGE_STATUS_NORMAL = 1;
/**
 * 最終納品物の承認待ち状態。
 */
export const MESSAGE_STATUS_CHECK_FINAL_VERSION_PENDING = 2;
/**
 * 最終納品物の承認済み状態。
 */
export const MESSAGE_STATUS_CHECK_FINAL_VERSION_ACCEPTED = 3;
/**
 * 最終納品物の承認が拒否された状態。
 */
export const MESSAGE_STATUS_CHECK_FINAL_VERSION_REJECTED = 4;

export class MessageModel extends BaseModel {
    id: number;
    conversationId: number;
    language: Language;
    body: string;
    bodyGeneratedFrom: string;
    /**
     * 見積の承認待ちプロセスや納品の承認待ちプロセスなどで使う。
     * 
     * **NOTICE** 0は通常状態ではない。デフォルトを0にしないこと。デフォルトは1
     */
    status: number;
    createdBy: number | null = null;
    creator: Creator | null = null;
    createdAt: string;
    files: FileModel[];
    fileBackRef: FileModel | null = null;
    /**
     * 既読のユーザーのIDのリスト
     */
    readList: number[];
    fromSystem = 0;
    replyTo: number | null = null;
    repliedMessage: MessageModel | null = null;

    clear() {
        this.id = 0;
        this.conversationId = 0;
        this.language = 'ja';
        this.body = '';
        this.bodyGeneratedFrom = '';
        this.status = MESSAGE_STATUS_NORMAL;
        this.createdBy = null;
        this.creator = null;
        this.createdAt = '';
        this.files = [];
        this.fileBackRef = null;
        this.readList = [];
        this.fromSystem = 0;
        this.replyTo = null;
        this.repliedMessage = null;
    }
}
